import { AssetsApi, Configuration, DefaultApi, DocumentApi, UsersApi, InspectionsApi, StatsApi, ReportsApi, ContractorsApi } from './api'
import axios from 'axios'

const config = new Configuration();
const axiosInstance = axios.create({ withCredentials: true })

// Switch the baseURL based on the environment
const baseURL = 'https://api.nova-comply.co.uk';


const inspectionsApi = (tenant_id) => {
    const inspectionsAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new InspectionsApi(
        config,
        baseURL,
        inspectionsAxios
    )
}

const documentApi = (tenant_id) => {
    const documentAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new DocumentApi(
        config,
        baseURL,
        documentAxios
    )
}

const assetsApi = (tenant_id) => {
    const assetAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new AssetsApi(
        config,
        baseURL,
        assetAxios
    )
}


const usersApi = (tenant_id) => {
    const usersAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new UsersApi(
        config,
        baseURL,
        usersAxios
    )
}

const statsApi = (tenant_id) => {
    const statsAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new StatsApi(
        config,
        baseURL,
        statsAxios
    )
}

const reportsApi = (tenant_id) => {
    const reportsAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new ReportsApi(
        config,
        baseURL,
        reportsAxios
    )
}

const contractorsApi = (tenant_id) => {
    const contractorsAxios = axios.create(
        {
            withCredentials: true,
            headers: {
                "x-tenant-id": tenant_id
            }
        }
    )
    return new ContractorsApi(
        config,
        baseURL,
        contractorsAxios
    )
}

const defaultApi = new DefaultApi(
    config,
    baseURL,
    axiosInstance
)

export { assetsApi, defaultApi, usersApi, documentApi, inspectionsApi, statsApi, reportsApi, contractorsApi };
